var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "com-input", class: { area: _vm.type === "textarea" } },
    [
      _vm.type === "text"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.tempValue,
                expression: "tempValue",
              },
            ],
            ref: "input",
            attrs: {
              type: "text",
              placeholder: _vm.placeholder,
              disabled: _vm.disabled,
            },
            domProps: { value: _vm.tempValue },
            on: {
              focus: _vm.focusHandle,
              blur: _vm.blurHandle,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.tempValue = $event.target.value
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "textarea"
        ? _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.tempValue,
                expression: "tempValue",
              },
            ],
            ref: "input",
            attrs: {
              type: "text",
              placeholder: _vm.placeholder,
              rows: _vm.rows,
            },
            domProps: { value: _vm.tempValue },
            on: {
              focus: _vm.focusHandle,
              blur: _vm.blurHandle,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.tempValue = $event.target.value
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLength && _vm.maxLength && _vm.getLength >= 0
        ? _c(
            "div",
            {
              ref: "limit",
              staticClass: "limit",
              class: { area: _vm.type === "textarea" },
            },
            [
              _c(
                "span",
                {
                  class:
                    _vm.getLength > 0 && _vm.getLength < _vm.maxLength
                      ? "length"
                      : _vm.getLength == _vm.maxLength
                      ? "maxLength"
                      : "",
                },
                [_vm._v(_vm._s(_vm.getLength))]
              ),
              _vm._v("/"),
              _c("span", [_vm._v(_vm._s(_vm.maxLength))]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }